import { useCallback, useEffect, useRef, useState } from 'preact/hooks'

export type StateUpdateCallback<S> = (value: S) => void
export type StateUpdaterWithCallback<S> = (value: S | ((prevState: S) => S), callback?: StateUpdateCallback<S>) => void

export function useStateWithCallback<S>(initialState: S | (() => S)): [S, StateUpdaterWithCallback<S>] {
  const [state, setState] = useState(initialState)
  const cbRef = useRef<StateUpdateCallback<S>>(null)

  const setStateWithCallback = useCallback((value: S | ((prevState: S) => S), cb?: StateUpdateCallback<S>) => {
    cbRef.current = cb
    setState(value)
  }, [])

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state)
      cbRef.current = null
    }
  }, [state])

  return [state, setStateWithCallback]
}
